const cancelPoliciesSelectsData = {
    countingType: {
        1: "От даты заезда",
        2: "От даты",
    },
    fine: {
        1: "Без штрафа",
        2: "Удерживается стоимость первых суток",
        3: "Удерживается % от суммы брони",
        4: "Невозвратный тариф",
    },
};

export default cancelPoliciesSelectsData;
